/**
 * Tracks in-flight HearSpace API requests by cache key to prevent duplicate
 * calls for identical acoustic parameters when multiple Redux actions fire
 * in rapid succession.
 */
const inFlightRequests = new Set<string>();

export const hearSpaceRequestManager = {
  isInFlight: (key: string): boolean => inFlightRequests.has(key),
  add: (key: string): void => { inFlightRequests.add(key); },
  remove: (key: string): void => { inFlightRequests.delete(key); },
  clear: (): void => { inFlightRequests.clear(); },
  size: (): number => inFlightRequests.size,
};
